import axios from "axios";

// Fetch blog data
const fetchBlogData = async (blogId) => {
  try {
    const url = `https://app.akiya2.com/blog/${blogId}`;
    // console.log('Fetching blog data from URL:', url);

    const response = await axios.get(url, { validateStatus: false });
    // console.log('Response status:', response.status);

    if (response.status !== 200) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = response.data;
    // console.log('Fetched blog data:', data);
    return data;
  } catch (error) {
    console.error('Failed to fetch blog data:', error.message);
    return null;
  }
};

// Fetch akiya data
const fetchAkiyaData = async (akiyaId) => {
  // return {
  //   municipalityName: "Shizuoka",
  //   serialNo: "12345",
  //   images: ["https://www.akiya2.com/images/sample-akiya.jpg"],
  // };

  try {
    const url = `https://app.akiya2.com/one_listing/${akiyaId}`;
    // console.log('Fetching akiya data from URL:', url);

    const response = await axios.get(url, { validateStatus: false });

    // console.log('Response status:', response.status);

    if (response.status !== 200) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = response.data;
    // console.log('Fetched akiya data:', data);

    return data;
  } catch (error) {
    console.error('Failed to fetch akiya data:', error.message);
    return null;
  }
};

// Fetch property data
const fetchPropertyData = async (propertyId) => {
  // return {
  //   name: "Traditional Japanese House",
  //   smallAbout: "A beautiful traditional house in rural Japan.",
  //   images: ["https://www.akiya2.com/images/sample-property.jpg"],
  // };
  try {
    const url = `https://app.akiya2.com/one_property/${propertyId}`;
    // console.log('Fetching property data from URL:', url);

    const response = await axios.get(url, { validateStatus: false });

    // console.log('Response status:', response.status);

    if (response.status !== 200) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = response.data;
    // console.log('Fetched property data:', data);

    return data;
  } catch (error) {
    console.error('Failed to fetch property data:', error.message);
    return null;
  }
};

// Fetch property data
const fetchKominkaData = async (kominkaId) => {
  // return {
  //   name: "Traditional Japanese House",
  //   smallAbout: "A beautiful traditional house in rural Japan.",
  //   images: ["https://www.akiya2.com/images/sample-property.jpg"],
  // };
  try {
    const url = `https://app.akiya2.com/individual_kominka/${kominkaId}`;
    // console.log('Fetching kominka data from URL:', url);

    const response = await axios.get(url, { validateStatus: false });

    // console.log('Response status:', response.status);

    if (response.status !== 200) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = response.data;
    // console.log('Fetched kominka data:', data);

    return data;
  } catch (error) {
    console.error('Failed to fetch kominka data:', error.message);
    return null;
  }
};

export const defaultMetaTags = {
  title: 'AKIYA2.0',
  description: 'Revitalizing Japan’s Akiya Homes and Communities',
  keywords: 'akiya, japan, real estate, abandoned homes, sustainable development',
  ogTitle: 'AKIYA2.0',
  ogDescription: 'Revitalizing Japan’s Akiya Homes and Communities',
  ogImage: 'https://www.akiya2.com/images/imagePlaceholder.webp',
  url: 'https://www.akiya2.com/',
  ogUrl: 'https://www.akiya2.com/',
};


export const staticMetaTags = {
  '/': {
    title: 'Buy Akiya Houses & Invest in Renovation | AKIYA2.0',
    description:
      'Discover AKIYA2.0: Buy Japan houses and invest in akiya renovation. Revitalize abandoned akiya houses through sustainable investment.',
    keywords: 'akiya, japan houses, buy japan houses, akiya investment, akiya renovation, abandoned homes, sustainable development',
    ogTitle: 'Buy Akiya Houses & Invest in Renovation | AKIYA2.0',
    ogDescription:
      'Discover AKIYA2.0: Buy Japan houses and invest in akiya renovation. Revitalize abandoned akiya houses through sustainable investment.',
    ogImage: 'https://www.akiya2.com/images/imagePlaceholder.webp',
    url: 'https://www.akiya2.com/',
    ogUrl: 'https://www.akiya2.com/',
  },
  '/akiya-search': {
    title: 'Find Akiya Houses for Sale in Japan | AKIYA2.0',
    description:
      'Search AKIYA2.0 to find akiya houses for sale in Japan. Buy and invest in akiya renovation across all prefectures.',
    keywords: 'akiya search, akiya houses for sale, japan properties, buy japan houses, akiya renovation, akiya investment',
    ogTitle: 'Find Akiya Houses for Sale in Japan | AKIYA2.0',
    ogDescription:
      'Search AKIYA2.0 to find akiya houses for sale in Japan. Buy and invest in akiya renovation across all prefectures.',
    ogImage: 'https://www.akiya2.com/images/imagePlaceholder.webp',
    url: 'https://www.akiya2.com/akiya-search',
    ogUrl: 'https://www.akiya2.com/akiya-search',
  },
  '/services/how-it-works': {
    title: 'Guide to Buy and Renovate Akiyas in Japan | AKIYA2.',
    description:
      'Learn how to buy and renovate akiya houses in Japan with AKIYA2.0. We offer seamless services for your akiya investment and renovation projects.',
    keywords: 'akiya services, how it works, buy japan houses, akiya renovation, akiya investment, japan real estate',
    ogTitle: 'Guide to Buy and Renovate Akiyas in Japan | AKIYA2.',
    ogDescription:
      'Learn how to buy and renovate akiya houses in Japan with AKIYA2.0. We offer seamless services for your akiya investment and renovation projects.',
    ogImage: 'https://www.akiya2.com/images/imagePlaceholder.webp',
    url: 'https://www.akiya2.com/services/how-it-works',
    ogUrl: 'https://www.akiya2.com/services/how-it-works',
  },
  '/services/what-it-costs': {
    title: 'Transparent Costs for Buying Houses in Japan | AKIYA2.0',
    description:
      'Discover the costs to buy and renovate akiya houses in Japan with AKIYA2.0. Transparent pricing from purchase to renovation—no hidden fees.',
    keywords: 'akiya costs, buy japan houses, akiya renovation, akiya investment, japan real estate, transparent pricing',
    ogTitle: 'Transparent Costs for Buying Houses in Japan | AKIYA2.0',
    ogDescription:
      'Discover the costs to buy and renovate akiya houses in Japan with AKIYA2.0. Transparent pricing from purchase to renovation—no hidden fees.',
    ogImage: 'https://www.akiya2.com/images/imagePlaceholder.webp',
    url: 'https://www.akiya2.com/services/what-it-costs',
    ogUrl: 'https://www.akiya2.com/services/what-it-costs',
  },
  '/our-projects': {
    title: 'Revitalizing Akiya Houses in Japan | AKIYA2.0 Projects',
    description:
      'Explore AKIYA2.0\'s projects revitalizing akiya houses in Japan. Invest in akiya renovation and support sustainable community growth.',
    keywords: 'akiya projects, akiya renovation, akiya investment, community growth, japan houses',
    ogTitle: 'Revitalizing Akiya Houses in Japan | AKIYA2.0 Projects',
    ogDescription:
      'Explore AKIYA2.0\'s projects revitalizing akiya houses in Japan. Invest in akiya renovation and support sustainable community growth.',
    ogImage: 'https://www.akiya2.com/images/imagePlaceholder.webp',
    url: 'https://www.akiya2.com/our-projects',
    ogUrl: 'https://www.akiya2.com/our-projects',
  },
  '/invest-in-akiya': {
    title: 'Invest in Akiya Properties in Japan | AKIYA2.0',
    description:
      'Invest in akiya with AKIYA2.0. Help revitalize Japan\'s abandoned houses into cultural treasures. Make a sustainable investment in Japan.',
    keywords: 'invest in akiya, akiya investment, buy japan houses, akiya renovation, japan houses',
    ogTitle: 'Invest in Akiya Properties in Japan | AKIYA2.0',
    ogDescription:
      'Invest in akiya with AKIYA2.0. Help revitalize Japan\'s abandoned houses into cultural treasures. Make a sustainable investment in Japan.',
    ogImage: 'https://www.akiya2.com/images/imagePlaceholder.webp',
    url: 'https://www.akiya2.com/invest-in-akiya',
    ogUrl: 'https://www.akiya2.com/invest-in-akiya',
  },
  '/community': {
    title: 'Join Our AKIYA2.0 Community & Mission in Japan',
    description:
      'Join AKIYA2.0\'s community to revitalize akiya houses in Japan. Stay updated with news, blogs, and internships on akiya investment and renovation.',
    keywords: 'akiya community, akiya investment, akiya renovation, japan houses, internships',
    ogTitle: 'Join Our AKIYA2.0 Community & Mission in Japan',
    ogDescription:
      'Join AKIYA2.0\'s community to revitalize akiya houses in Japan. Stay updated with news, blogs, and internships on akiya investment and renovation.',
    ogImage: 'https://www.akiya2.com/images/imagePlaceholder.webp',
    url: 'https://www.akiya2.com/community',
    ogUrl: 'https://www.akiya2.com/community',
  },
  '/news': {
    title: 'AKIYA2.0 News: Updates on Akiya Houses in Japan',
    description:
      'Stay updated with AKIYA2.0\'s news on revitalizing akiya houses in Japan. Follow our journey in akiya investment and renovation.',
    keywords: 'akiya news, akiya investment, akiya renovation, japan houses, akiya banks',
    ogTitle: 'AKIYA2.0 News: Updates on Akiya Houses in Japan',
    ogDescription:
      'Stay updated with AKIYA2.0\'s news on revitalizing akiya houses in Japan. Follow our journey in akiya investment and renovation.',
    ogImage: 'https://www.akiya2.com/images/imagePlaceholder.webp',
    url: 'https://www.akiya2.com/news',
    ogUrl: 'https://www.akiya2.com/news',
  },
  '/about-us': {
    title: 'Revitalizing Akiyas and Kominkas in Japan | About AKIYA2.0',
    description:
      'Learn about AKIYA2.0\'s mission to revitalize akiya houses in Japan. Our team is dedicated to akiya renovation and sustainable community growth.',
    keywords: 'about AKIYA2.0, akiya renovation, akiya investment, japan houses, cultural heritage',
    ogTitle: 'Revitalizing Akiyas and Kominkas in Japan | About AKIYA2.0',
    ogDescription:
      'Learn about AKIYA2.0\'s mission to revitalize akiya houses in Japan. Our team is dedicated to akiya renovation and sustainable community growth.',
    ogImage: 'https://www.akiya2.com/images/imagePlaceholder.webp',
    url: 'https://www.akiya2.com/about-us',
    ogUrl: 'https://www.akiya2.com/about-us',
  },
  '/akiya-concierge': {
    title: 'Your Guide & Concierge for Akiya Homes | AKIYA2.0',
    description:
      'Discover AKIYA2.0 Concierge, your personalized guide to buying and renovating akiya houses in Japan. Experience seamless akiya investment services.',
    keywords: 'akiya concierge, buy japan houses, akiya renovation, akiya investment, japan houses',
    ogTitle: 'Your Guide & Concierge for Akiya Homes | AKIYA2.0',
    ogDescription:
      'Discover AKIYA2.0 Concierge, your personalized guide to buying and renovating akiya houses in Japan. Experience seamless akiya investment services.',
    ogImage: 'https://www.akiya2.com/images/imagePlaceholder.webp',
    url: 'https://www.akiya2.com/akiya-concierge',
    ogUrl: 'https://www.akiya2.com/akiya-concierge',
  },
  '/terms': {
    title: 'AKIYA2.0 Terms of Use and Privacy Policy',
    description:
      'Read AKIYA2.0\'s Terms of Use and Privacy Policy. Learn how we protect your data and our commitment to transparency.',
    keywords: 'terms of use, privacy policy, AKIYA2.0, akiya',
    ogTitle: 'AKIYA2.0 Terms of Use and Privacy Policy',
    ogDescription:
      'Read AKIYA2.0\'s Terms of Use and Privacy Policy. Learn how we protect your data and our commitment to transparency.',
    ogImage: 'https://www.akiya2.com/images/imagePlaceholder.webp',
    url: 'https://www.akiya2.com/terms',
    ogUrl: 'https://www.akiya2.com/terms',
  },
  '/internship': {
    title: 'Work on Revitalizing Homes in Japan | AKIYA2.0 Internship',
    description:
      'Join our internship program to gain hands-on experience in fields like architecture, marketing, and software development. Learn while revitalizing Akiyas!',
    keywords: 'AKIYA2.0, Akiya internships, Japan internship program, architecture internships Japan, marketing internships Japan, software development internships, AKIYA2.0 internship, real estate internships Japan, hands-on internships, internship opportunities Japan, learn architecture Japan, work in Japan internships',
    ogTitle: 'Work on Revitalizing Homes in Japan | AKIYA2.0 Internship',
    ogDescription:
      'Join our internship program to gain hands-on experience in fields like architecture, marketing, and software development. Learn while revitalizing Akiyas!',
    ogImage: 'https://www.akiya2.com/images/imagePlaceholder.webp',
    url: 'https://www.akiya2.com/internship',
    ogUrl: 'https://www.akiya2.com/internship',
  },
  '/kominka': {
    title: 'Buy Kominka & Akiya Houses in Japan | AKIYA2.0',
    description:
      'Discover special grade Kominkas across Japan, curated by AKIYA2.0 and Kominka Smile. Buy these heritage homes directly from Kominka Smile.',
    keywords: 'kominka, traditional homes, buy japan houses, heritage homes, akiya renovation, akiya investment',
    ogTitle: 'Buy Kominka & Akiya Houses in Japan | AKIYA2.0',
    ogDescription:
      'Discover special grade Kominkas across Japan, curated by AKIYA2.0 and Kominka Smile. Buy these heritage homes directly from Kominka Smile.',
    ogImage: 'https://www.akiya2.com/images/imagePlaceholder.webp',
    url: 'https://www.akiya2.com/kominka',
    ogUrl: 'https://www.akiya2.com/kominka',
  },
  '/blogs': {
    title: 'Buying Akiya Houses: Insights | AKIYA2.0 Blogs',
    description:
      'Read AKIYA2.0\'s blogs for insights on buying and renovating akiya houses in Japan. Get expert tips on akiya investment and renovation.',
    keywords: 'akiya blogs, akiya investment, akiya renovation, buy japan houses, abandoned houses japan',
    ogTitle: 'Buying Akiya Houses: Insights | AKIYA2.0 Blogs',
    ogDescription:
      'Read AKIYA2.0\'s blogs for insights on buying and renovating akiya houses in Japan. Get expert tips on akiya investment and renovation.',
    ogImage: 'https://www.akiya2.com/images/imagePlaceholder.webp',
    url: 'https://www.akiya2.com/blogs',
    ogUrl: 'https://www.akiya2.com/blogs',
  },
  '/special-property/SP0': {
    title: 'Renovated Akiya House for Sale in Japan | AKIYA2.0',
    description:
      'Buy a renovated akiya house in Japan with AKIYA2.0. Traditional charm meets modern comfort—a ready-to-move-in home ideal for akiya investment.',
    keywords: 'akiya house for sale, buy japan houses, akiya renovation, akiya investment, renovated akiya house',
    ogTitle: 'Renovated Akiya House for Sale in Japan | AKIYA2.0',
    ogDescription:
      'Buy a renovated akiya house in Japan with AKIYA2.0. Traditional charm meets modern comfort—a ready-to-move-in home ideal for akiya investment.',
    ogImage: 'https://www.akiya2.com/images/imagePlaceholder.webp',
    url: 'https://www.akiya2.com/special-property/SP0',
    ogUrl: 'https://www.akiya2.com/special-property/SP0',
  },
};



// Function to strip HTML tags from a string
function stripHtmlTags(content) {
  return content.replace(/<\/?[^>]+(>|$)/g, ''); // Regular expression to remove HTML tags
}
function sanitizeHtmlContent(content) {
  // Remove <meta>, <title>, and <style> tags and their content
  const sanitizedContent = content
    .replace(/<meta[^>]*>/gi, '')   // Remove <meta> tags
    .replace(/<title[^>]*>.*<\/title>/gi, '')   // Remove <title> tags and content
    .replace(/<style[^>]*>.*<\/style>/gi, '')   // Remove <style> tags and content
    .replace(/<\/?[^>]+(>|$)/g, '');  // Remove all remaining HTML tags

  return sanitizedContent.trim();
}

export const dynamicMetaTagGenerators = {
  '/blogs/:id/:slug': async (params) => {
    const blog = await fetchBlogData(params.id);
    if (!blog){
      // console.log("failed blog");
      return defaultMetaTags;
    } 

    const sanitizedContent = sanitizeHtmlContent(blog.blog_content);
    const description = sanitizedContent
      ? `${sanitizedContent.split(' ').slice(0, 22).join(' ')}...`
      : '';

    return {
      title: blog.blog_heading,
      description: description,
      keywords: blog.keywords || 'akiya, japanese akiya, japanese cheap houses, renovation, japanese abandoned houses, japan',
      ogTitle: blog.blog_heading,
      ogDescription: description,
      ogImage: blog.coverImage,
      url: `https://www.akiya2.com/blogs/${params.id}/${params.slug}`,
      ogUrl: `https://www.akiya2.com/blogs/${params.id}/${params.slug}`,
    };
  },

  '/prefecture-listing/:prefectureName': async (params) => {
    const prefectureName = params.prefectureName;
    return {
      title: `${prefectureName} Akiya listings in Japan | AKIYA2.0`,
      description: `Explore exclusive Akiya listings from municipal websites and Akiya banks in ${prefectureName}, a prime region for traditional Japanese homes and cultural heritage.`,
      keywords: `${prefectureName}, akiya listings, japan, traditional homes akiya banks, akiya banks ${prefectureName}`,
      ogTitle: `${prefectureName} Akiya listings in Japan | AKIYA2.0`,
      ogDescription: `Explore exclusive Akiya listings from municipal websites and Akiya banks in ${prefectureName}.`,
      ogImage: 'https://www.akiya2.com/images/imagePlaceholder.webp',
      url: `https://www.akiya2.com/prefecture-listing/${prefectureName}`,
      ogUrl: `https://www.akiya2.com/prefecture-listing/${prefectureName}`,
    };
  },
  '/individual-akiya/:akiyaId': async (params) => {
    // Fetch the Akiya data from the backend
    const akiya = await fetchAkiyaData(params.akiyaId);
    
    if (!akiya) return defaultMetaTags;
  
    // Extract municipality name and serial number from property_id
    const propertyIdParts = akiya.property_id.split('-');
    
    // The third part is the municipality name, capitalized
    const municipalityName = propertyIdParts[2];
    
    // The last part (fourth) is a string number, so we increment it by 1 to get the serial number
    const serialNo = (parseInt(propertyIdParts[3], 10) + 1).toString();
  
    return {
      title: `${municipalityName}’s Listing No:${serialNo}`,
      description: `Explore traditional Japanese houses in ${municipalityName}, compiled and translated by the AKIYA2.0 team.`,
      keywords: `${municipalityName}, akiya, listing, traditional home, heritage`,
      ogTitle: `${municipalityName}’s Listing No:${serialNo}`,
      ogDescription: `Explore traditional Japanese houses in ${municipalityName}, compiled and translated by Akiya2.0.`,
      ogImage: akiya.Images && akiya.Images.length > 0 ? akiya.Images[0] : 'https://www.akiya2.com/images/imagePlaceholder.webp',
      url: `https://www.akiya2.com/individual-akiya/${akiya.property_id}`,
      ogUrl: `https://www.akiya2.com/individual-akiya/${akiya.property_id}`,
    };
  },
  '/property/:propertyId': async (params) => {
    const property = await fetchPropertyData(params.propertyId);
    if (!property) return defaultMetaTags;
    return {
      title: property.propertyName,
      description: property.smallAbout,
      keywords: `${property.serialNumber} a property of AKIYA2.0, akiya` || 'A property of AKIYA2.0, akiya',
      ogTitle: property.propertyName,
      ogDescription: property.smallAbout,
      ogImage:
        property.images && property.images.length > 0
          ? property.images[0]
          : 'https://www.akiya2.com/images/imagePlaceholder.webp',
      url: `https://www.akiya2.com/property/${params.propertyId}`,
      ogUrl: `https://www.akiya2.com/property/${params.propertyId}`,
    };
  },
  '/individual_kominka/:kominka_id': async (params) => {
    // Fetch the Kominka data from the backend
    const kominka = await fetchKominkaData(params.kominka_id); // Assuming you have a fetch function for this
  
    if (!kominka) return defaultMetaTags;
  
    const { prefectureName, cityName, price, built, mainLink, images } = kominka;
  
    return {
      title: `${cityName}: Akiya-${kominka.post_id}`,
      description: `Explore this beautiful Kominka (Akiya) in ${cityName}, ${prefectureName}, now available for purchase on Kominka Smile.`,
      keywords: `${prefectureName}, ${cityName}, kominka, traditional homes, Japan properties, heritage homes, AKIYA2.0 partnership, kominka listings, akiya`,
      ogTitle: `${cityName}, ${prefectureName} - Kominka Listing No:${kominka.post_id}`,
      ogDescription: `Explore this beautiful Kominka (Akiya) in ${cityName}, ${prefectureName}, now available for purchase on Kominka Smile.`,
      ogImage: images && images.length > 0 ? `https://app.akiya2.com/${images[0]}` : 'https://www.akiya2.com/images/imagePlaceholder.webp',
      url: `https://www.akiya2.com/individual_kominka/${kominka.post_id}`,
      ogUrl: `https://www.akiya2.com/individual_kominka/${kominka.post_id}`,
    };
  },
};

export async function getMetaTags(path, params = {}) {

  // Remove trailing slash if not root
  if (path.length > 1 && path.endsWith('/')) {
    path = path.slice(0, -1);
  }
  
  // Check if it's a static route
  if (staticMetaTags[path]) {
    return staticMetaTags[path];
  }

  // Check if it's a dynamic route
  for (const [route, generator] of Object.entries(dynamicMetaTagGenerators)) {
    const match = matchPath(route, path);
    if (match) {
      return await generator(match.params);
    }
  }
  // console.log("No match found")
  // Return default tags if no match found
  return defaultMetaTags;
}

// Simple path matching function
function matchPath(route, path) {
  const routeParts = route.split('/');
  const pathParts = path.split('/');

  if (routeParts.length !== pathParts.length) return null;

  const params = {};
  for (let i = 0; i < routeParts.length; i++) {
    if (routeParts[i].startsWith(':')) {
      params[routeParts[i].slice(1)] = pathParts[i];
    } else if (routeParts[i] !== pathParts[i]) {
      return null;
    }
  }

  return { params };
}

// module.exports = { getMetaTags };
export default getMetaTags;